import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { getThemeConfig, ShimmerThumbnailCardContainer, ShimmerThumbnailCardContent, ShimmerThumbnailCardContentWrapper } from '../styles';
import ShimmerBodyText from './ShimmerBodyText';
import ShimmerBookCover from './ShimmerBookCover';
import ShimmerTitleText from './ShimmerTitleText';

var ShimmerThumbnailCard = function ShimmerThumbnailCard(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "".concat(387 / 16, "rem") : _ref$width,
      dataTest = _ref['data-test'],
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["size", "width", "data-test", "theme"]);

  var componentTheme = useComponentTheme({
    name: 'Shimmer',
    theme: getThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(ShimmerThumbnailCardContainer, _extends({
    "data-test": dataTest,
    $width: width,
    size: size,
    customTheme: componentTheme
  }, props), /*#__PURE__*/React.createElement(ShimmerThumbnailCardContentWrapper, {
    customTheme: componentTheme
  }, /*#__PURE__*/React.createElement(ShimmerBookCover, {
    size: size
  }), /*#__PURE__*/React.createElement(ShimmerThumbnailCardContent, null, /*#__PURE__*/React.createElement(ShimmerTitleText, null), /*#__PURE__*/React.createElement(ShimmerBodyText, {
    line: size === 'small' ? 1 : 2,
    "data-test": "".concat(dataTest, "-body-text")
  }))));
};

ShimmerThumbnailCard.displayName = 'ShimmerThumbnailCard';
export default ShimmerThumbnailCard;